import apiClient from '../network/apiClient'
import ShowNotifications from '../utils/notification'

class materialApi {
  async materialCreate(input) {
    try {
      const response = await apiClient.post('/material', input)

      if (response.status == 200 || response.status == 201) {
        ShowNotifications.showAlertNotification(response.data.message, true)
        return {
          status: true
        }
      } else {
        ShowNotifications.showAlertNotification('Something went wrong', true)
        return {
          status: false
        }
      }
    } catch (err) {
      ShowNotifications.showAxiosErrorAlert(err)
      return {
        response: null,
        status: false
      }
    }
  }

  async materialList(input) {
    const params = {
      page: input.page || 0,
      limit: input.limit || 10,
    };
    if (input.status) {
      params.status = input.status;
    }

    if (input?.filters && typeof input.filters === 'object' && Object.keys(input.filters).length > 0) {
      if (input.filters.name && typeof input.filters.name === 'string') {
        params.search = input.filters.name.trim();
      }
    }

    try {
      const response = await apiClient.get('/material/list/dtls', {
        params
      })

      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        return {
          status: false
        }
      }
    } catch (error) {
      return {
        response: null,
        status: false
      }
    }
  }

  async materialDetails(id) {
    try {
      const response = await apiClient.get(`/material/${id}`)

      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        return {
          status: false
        }
      }
    } catch (error) {
      return {
        response: null,
        status: false
      }
    }
  }

  async updateMaterial(input, id) {
    try {
      const response = await apiClient.patch(`/material/edit/${id}`, input)
      if (response.status == 200 || response.status == 201) {
        ShowNotifications.showAlertNotification(response.data.message, true)
        return {
          status: true
        }
      } else {
        ShowNotifications.showAlertNotification('Something went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      ShowNotifications.showAxiosErrorAlert(error)
      return {
        response: null,
        status: false
      }
    }
  }

  async deleteMaterial(id) {
    try {
      const response = await apiClient.patch(`/material/delete/${id}`)

      if (response.status == 200 || response.status == 201) {
        ShowNotifications.showAlertNotification(response.data.message, true)
        return {
          response: response.data,
          status: true
        }
      } else {
        ShowNotifications.showAlertNotification('Something went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      ShowNotifications.showAxiosErrorAlert(error)
      return {
        response: null,
        status: false
      }
    }
  }
}

const MaterialApi = new materialApi()
export default MaterialApi
